import { render, staticRenderFns } from "./BarraPos.vue?vue&type=template&id=07cc1b54&scoped=true"
import script from "./BarraPos.vue?vue&type=script&lang=js"
export * from "./BarraPos.vue?vue&type=script&lang=js"
import style0 from "./BarraPos.vue?vue&type=style&index=0&id=07cc1b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc1b54",
  null
  
)

export default component.exports